const clean = value => String(value == null ? '' : value).trim()

// Validate form fields before generating the email client URL.
function createEmailDraft(formType, values, site) {
  const name = clean(values.userName)
  const email = clean(values.email).replace(/＠/g, '@')
  if (name.length < 3 || name.length > 32 || /[\r\n]/.test(name)) {
    return { error: 'Name must contain 3 to 32 characters.' }
  }
  if (email.length > 200 || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
    return { error: 'Please enter a valid email address.' }
  }

  let subject
  let lines
  if (formType === 'warranty') {
    const order = clean(values.amazonOrderId)
    if (!/^\d{17}$/.test(order) && !/^\d{3}[-ー―‐～]\d{7}[-ー―‐～]\d{7}$/.test(order)) {
      return { error: 'Please enter a valid Amazon order ID.' }
    }
    subject = `[${site.brand}] Warranty Request - ${order}`
    lines = [`Website: ${site.brand}`, `Amazon Order ID: ${order}`, `Name: ${name}`, `Email: ${email}`]
  } else if (formType === 'contact') {
    const title = clean(values.subject)
    const message = clean(values.message)
    if (title.length < 3 || title.length > 200 || /[\r\n]/.test(title)) {
      return { error: 'Subject must contain 3 to 200 characters on one line.' }
    }
    if (message.length < 3 || message.length > 2000) {
      return { error: 'Message must contain 3 to 2000 characters.' }
    }
    subject = `[${site.brand}] Contact - ${title}`
    lines = [`Website: ${site.brand}`, `Name: ${name}`, `Email: ${email}`,
      `Phone: ${clean(values.phone)}`, `Subject: ${title}`, '', 'Message:', message]
  } else {
    throw new Error('Unknown email form type')
  }

  const body = lines.join('\n').replace(/\r?\n/g, '\r\n')
  return {
    recipient: site.supportEmail,
    subject,
    body,
    mailto: `mailto:${site.supportEmail}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`
  }
}

module.exports = { createEmailDraft }
